/*
  neotes Diagnostik v2 – Interaktion für templates/collection.diagnostik-v2.json
  - Anliegenauswahl (Ansichtswechsel), Metabolom-Grafik (zwei Zustände), Sprunglinks mit Sticky-Header-Abstand.
  - Datenschutz: Auswahlzustand nur im Arbeitsspeicher der geöffneten Seite. Keine Cookies, kein Storage,
    keine URL-/Hash-Änderung, keine dataLayer-/Analytics-/Pixel-Events.
  - Theme-Editor: Initialisierung bei shopify:section:load, Aufräumen bei shopify:section:unload,
    keine doppelten Handler (AbortController je Instanz).
*/
(function () {
  'use strict';
  if (window.__ndiagInit) return;
  window.__ndiagInit = true;

  var instances = new WeakMap();

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function headerOffset() {
    var root = getComputedStyle(document.documentElement);
    var v = parseFloat(root.getPropertyValue('--header-height-sticky')) || parseFloat(root.getPropertyValue('--header-height'));
    if (!v || isNaN(v)) v = 96;
    return v + 16;
  }

  function scrollToElement(el) {
    if (!el) return;
    var top = Math.max(0, Math.round(el.getBoundingClientRect().top + window.pageYOffset - headerOffset()));
    try {
      window.scrollTo({ top: top, behavior: reducedMotion() ? 'instant' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  function focusWithoutScroll(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* ---------- Anliegenauswahl ---------- */
  function initTopics(root) {
    var ctrl = new AbortController();
    var opts = { signal: ctrl.signal };
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ndiag-topic]'));
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-ndiag-view]'));
    var panel = root.querySelector('[data-ndiag-panel]');
    var grid = root.querySelector('[data-ndiag-grid]');
    var status = root.querySelector('[data-ndiag-status]');
    if (!buttons.length || !views.length) return function () {};

    function select(index, scroll) {
      var view = null;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-ndiag-topic') === index)); });
      views.forEach(function (v) {
        var on = v.getAttribute('data-ndiag-view') === index;
        v.hidden = !on;
        if (on) view = v;
      });
      if (status && view) {
        status.textContent = '';
        var text = view.getAttribute('data-ndiag-announce') || '';
        window.setTimeout(function () { status.textContent = text; }, 60);
      }
      if (scroll && panel) {
        var rect = panel.getBoundingClientRect();
        var off = headerOffset();
        if (rect.top < off || rect.top > window.innerHeight * 0.45) scrollToElement(panel);
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        select(b.getAttribute('data-ndiag-topic'), true);
      }, opts);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ndiag-back]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToElement(root.querySelector('.ndiag-head') || grid);
        var active = buttons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || buttons[0];
        focusWithoutScroll(active);
      }, opts);
    });

    /* Theme-Editor: ausgewählten Block anzeigen */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var idx = e.target.getAttribute && e.target.getAttribute('data-ndiag-topic');
      if (idx !== null && idx !== undefined) select(idx, false);
    }, opts);

    root.classList.add('is-ready');
    return function () { ctrl.abort(); root.classList.remove('is-ready'); };
  }

  /* ---------- Metabolom-Grafik ---------- */
  function initDiagram(root) {
    var ctrl = new AbortController();
    var opts = { signal: ctrl.signal };
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ndiag-tab]'));
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-ndiag-tabview]'));
    if (!tabs.length || !views.length) return function () {};

    function show(id) {
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-ndiag-tab') === id)); });
      views.forEach(function (v) { v.hidden = v.id !== id; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-ndiag-tab')); }, opts);
    });
    var initial = tabs.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0] || tabs[0];
    show(initial.getAttribute('data-ndiag-tab'));
    root.classList.add('is-ready');
    return function () {
      ctrl.abort();
      root.classList.remove('is-ready');
      views.forEach(function (v) { v.hidden = false; });
    };
  }

  /* ---------- Sprunglinks innerhalb der Diagnostik-Sections ---------- */
  function initAnchors(root) {
    var ctrl = new AbortController();
    Array.prototype.forEach.call(root.querySelectorAll('a[data-ndiag-anchor]'), function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        scrollToElement(target);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        focusWithoutScroll(target);
      }, { signal: ctrl.signal });
    });
    return function () { ctrl.abort(); };
  }

  function initScope(scope) {
    var roots = [];
    if (scope.matches && scope.matches('.ndiag')) roots.push(scope);
    Array.prototype.push.apply(roots, scope.querySelectorAll('.ndiag'));
    roots.forEach(function (root) {
      if (instances.has(root)) return;
      var cleanups = [initAnchors(root)];
      if (root.hasAttribute('data-ndiag-topics')) cleanups.push(initTopics(root));
      Array.prototype.forEach.call(root.querySelectorAll('[data-ndiag-diagram]'), function (d) { cleanups.push(initDiagram(d)); });
      instances.set(root, cleanups);
    });
  }

  function destroyScope(scope) {
    var roots = [];
    if (scope.matches && scope.matches('.ndiag')) roots.push(scope);
    Array.prototype.push.apply(roots, scope.querySelectorAll('.ndiag'));
    roots.forEach(function (root) {
      var cleanups = instances.get(root);
      if (!cleanups) return;
      cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
      instances.delete(root);
    });
  }

  function boot() { initScope(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyScope(e.target); });
})();
